import gql from "graphql-tag";

export const LOGIN_USER = gql`
    mutation LOGIN_USER($email: String!, $password: String! ){
         tokenAuth(email: $email, password: $password){
            token,
            user {
                id,
                publicId,
                avatar
                firstName,
                lastName,
                name
                email,
                phoneNumber,
                isActive,
                isStaff,
                outletId{
                    publicId
                }
            }
             permissions
        }
    }
`;

export const VERIFY_TOKEN = gql`
    mutation VERIFY_TOKEN($token: String!){
        verifyToken(token: $token) {
            payload,
        }
    }
`;

export const REQUEST_PASSWORD_RESET = gql`
    mutation REQUEST_PASSWORD_RESET($email: String!){
        requestReset(email: $email) {
            message
        }
    }
`;

export const FORGOT_PASSWORD = gql`
    mutation FORGOT_PASSWORD($resetToken: String!, $newPassword: String!, $confirmPassword: String!){
        changePassword(resetToken: $resetToken, newPassword: $newPassword, confirmPassword: $confirmPassword) {
            message,
        }
    }
`;

export const CHANGE_PASSWORD = gql`
    mutation CHANGE_PASSWORD($oldPassword: String!, $newPassword: String!, $confirmPassword: String!){
        changePassword(oldPassword: $oldPassword, newPassword: $newPassword, confirmPassword: $confirmPassword) {
            message,
        }
    }
`;

export const ACTIVE_USER = gql`
    query ACTIVE_USER{
        me{
            id,
            publicId,
            firstName,
            lastName,
            email,
            phoneNumber,
            profile {
                id,
                idNumber,
                kraPin,
                nhif,
                nssf,
                physicalAddress,
                poBox
            }
        }
    }
`;
